import React, { useEffect, useState } from 'react';
import { Modal, Form, Col } from "react-bootstrap";
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-phone-number-input/style.css'

//import cores
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import useAuth from "hooks/useAuth"
import api from "assets/services/api";
import TimeInput from 'services/TimeInput';

//import material ui
import AddAlert from "@material-ui/icons/AddAlert";
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from '@material-ui/core/Checkbox';

const styles = {
    btnFindClient: {
        backgroundColor: "#4169e1",
        marginTop: "25%",
        '&:hover': {
            backgroundColor: '#303f9f',
        },
    },
};

const useStyles = makeStyles(styles);

function ModalUpdateClients(props) {
    const classStyles = useStyles();

    const { storageId, storageUserType } = useAuth();

    const [br, setBR] = useState(false);
    const [fantasy_name, setFantasy_name] = useState(props.props.fantasy_name);
    const [social_reason, setSocial_reason] = useState(props.props.social_reason);
    const [address_delivery, setAddress_delivery] = useState(props.props.address_delivery);
    const [reference_comercial, setReference_comercial] = useState(props.props.reference_comercial);
    const [hour_delivery, setHour_delivery] = useState([]);
    const [cnpj, setCnpj] = useState(props.props.cnpj);
    const [number, setNumber] = useState(props.props.number);
    const [mask, setMask] = useState("");
    const [obs, setObs] = useState(props.props.observation);
    const [controlSnack, setControlSnack] = useState(false);
    const [preference, setPreference] = useState(props.props.preference);
    const [address, setAddress] = useState(props.props.address);
    const [neighborhood, setNeighborhood] = useState(props.props.neighborhood);
    const [city, setCity] = useState(props.props.city);
    const [cep, setCep] = useState(props.props.cep);
    const [complement, setComplement] = useState(props.props.complement);
    const [uf, setUf] = useState(props.props.uf);
    const [email, setEmail] = useState(props.props.email);
    const [state_reg, setState_reg] = useState(props.props.stateReg);
    const [latitude, setLatitude] = useState(props.props.latitude);
    const [longitude, setLongitude] = useState(props.props.longitude);
    const [message, setMessage] = useState(true);
    const [carrier, setCarrier] = useState(false);
    const [id_enterprise, setId_enterprise] = useState(props.props.id_enterprise);
    const [enterprises, setEnterprises] = useState([]);

    const [preferences, setPreferences] = useState([
        { description: "A VISTA", id: 0 }
    ]);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        loadPayments();
        loadEnterprises();
        if (props.props.hour_delivery) {
            const hours = props.props.hour_delivery.split('-');
            setHour_delivery([hours[0] || "00:00", hours[1] || "23:59"]);
        } else {
            setHour_delivery(["00:00", "23:59"]);
        };

    }, []);

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    const loadPayments = async () => {
        const responsePayment = await api.get('/payment')
        setPreferences(responsePayment.data)
    }
    async function loadEnterprises() {
        const response = await api.get(`/enterprise/${storageId}`);
        console.log(response.data)
        setEnterprises(response.data.enterprises);
    };

    async function handleUpdateClient(e) {
        e.preventDefault();
        const response = await api.put('/client/' + props.props.id, {
            fantasy_name: fantasy_name,
            social_reason: social_reason,
            address: address,
            neighborhood: neighborhood,
            city: city,
            cep: cep,
            number: number,
            cnpj: cnpj,
            id_admin: storageId,
            preference: preference,
            address_delivery: address_delivery,
            hour_delivery: `${hour_delivery[0]}-${hour_delivery[1]}`,
            reference_comercial: reference_comercial,
            observation: obs,
            userType: storageUserType,
            uf: uf,
            email: email,
            state_reg: state_reg,
            latitude: latitude,
            longitude: longitude,
            message: message,
            complement: complement,
            carrier,
            id_enterprise
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        if (response.status === 200) {
            props.getAllClients();
            props.onHide();
        }

    }

    async function findClient(cnpj) {

        const response = await api.post('client/find', {
            cnpj: cnpj,
            id_admin: storageId,
            upd: true
        })

        if (response.status === 210) {
            return alert(response.data.message);
        }

        setState_reg(response.data[0].state_reg)
        setSocial_reason(response.data[0].social_reason)
        setFantasy_name(response.data[0].fantasy_name)
        setAddress(response.data[0].address)
        setUf(response.data[0].uf)
        setCity(response.data[0].city)
        setNeighborhood(response.data[0].neighborhood)
        setCep(response.data[0].cep)
        setEmail(response.data[0].email)
        setComplement(response.data[0].complement)
        setLatitude(response.data[0].latitude)
        setLongitude(response.data[0].longitude)
        setNumber(response.data[0].number)
    };
    async function addHours(e, type) {
        if (type === 'start') {
            setHour_delivery([e.target.value, hour_delivery[1]]);
        } else if (type === 'end') {
            setHour_delivery([hour_delivery[0], e.target.value]);
        };
    };

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar cliente
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleUpdateClient}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>CNPJ/CPF</Form.Label>
                            <CpfCnpj
                                value={cnpj}
                                className="form-control"
                                placeholder="Digite um CPF ou CNPJ"
                                type="tel"
                                onChange={(event, type) => {
                                    setCnpj(event.target.value);
                                    setMask(type === "CPF");
                                }}
                                disabled={true}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Button as={Col} className={classStyles.btnFindClient} onClick={() => findClient(cnpj)} >
                                Buscar
                            </Button>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>RAZÃO SOCIAL</Form.Label>
                            <Form.Control
                                value={social_reason}
                                className="form-control"
                                placeholder="Razão social"
                                type="text"
                                onChange={(event) => {
                                    setSocial_reason(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>NOME FANTASIA</Form.Label>
                            <Form.Control
                                value={fantasy_name}
                                className="form-control"
                                placeholder="Nome fantasia"
                                type="text"
                                onChange={(event) => {
                                    setFantasy_name(event.target.value)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>ENDEREÇO</Form.Label>
                            <Form.Control
                                value={address}
                                className="form-control"
                                placeholder="Endereço"
                                type="text"
                                onChange={(event) => {
                                    setAddress(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>COMPLEMENTO</Form.Label>
                            <Form.Control
                                value={complement}
                                className="form-control"
                                placeholder="Complemento"
                                type="text"
                                onChange={(event) => {
                                    setComplement(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formGridName">
                            <Form.Label>NUMERO</Form.Label>
                            <Form.Control
                                value={number}
                                className="form-control"
                                placeholder="Numero"
                                type="text"
                                onChange={(event) => {
                                    setNumber(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={3} controlId="formGridName">
                            <Form.Label>BAIRRO</Form.Label>
                            <Form.Control
                                value={neighborhood}
                                className="form-control"
                                placeholder="Bairro"
                                type="text"
                                onChange={(event) => {
                                    setNeighborhood(event.target.value)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xs={4} controlId="formGridName">
                            <Form.Label>CIDADE</Form.Label>
                            <Form.Control
                                value={city}
                                className="form-control"
                                placeholder="Cidade"
                                type="text"
                                onChange={(event) => {
                                    setCity(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formGridName">
                            <Form.Label>ESTADO</Form.Label>
                            <Form.Control
                                value={uf}
                                className="form-control"
                                placeholder="UF"
                                type="text"
                                onChange={(event) => {
                                    setUf(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={2} controlId="formGridName">
                            <Form.Label>CEP</Form.Label>
                            <Form.Control
                                value={cep}
                                className="form-control"
                                placeholder="CEP"
                                type="text"
                                onChange={(event) => {
                                    setCep(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={5} controlId="formGridName">
                            <Form.Label>EMAIL PARA NF</Form.Label>
                            <Form.Control
                                value={email}
                                className="form-control"
                                placeholder="Email nota fiscal"
                                type="text"
                                onChange={(event) => {
                                    setEmail(event.target.value)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>ENDEREÇO ENTREGA</Form.Label>
                            <Form.Control
                                value={address_delivery}
                                className="form-control"
                                placeholder="Endereço entrega"
                                type="text"
                                onChange={(event) => {
                                    setAddress_delivery(event.target.value)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName" >
                            <Form.Label>HORARIO DE ENTREGA</Form.Label>
                            <Form.Row>
                                <Form.Group xs={12} sm={12} md={5} controlId="formGridName" >
                                    <TimeInput
                                        name="appointment-time"
                                        value={hour_delivery[0]}
                                        onChange={(e) => {
                                            addHours(e, 'start')
                                        }}
                                        placeholder="Digite o horário"
                                    />
                                </Form.Group>
                                <Form.Group xs={12} sm={12} md={2} controlId="formGridName" >
                                    <Form.Label style={{ padding: '1em 3em 3em 3em', fontWeight: 'bold', color: 'black' }}>às</Form.Label>
                                </Form.Group>
                                <Form.Group xs={12} sm={12} md={5} controlId="formGridName" >
                                    <TimeInput
                                        name="appointment-time"
                                        value={hour_delivery[1]}
                                        onChange={(e) => {
                                            addHours(e, 'end')
                                        }}
                                        placeholder="Digite o horário"
                                    />
                                </Form.Group>
                            </Form.Row>
                        </Form.Group>
                        <Form.Group as={Col} controlId="{`type-${index}`}">
                            <Form.Label>DEPOSITO</Form.Label>
                            <Form.Control onChange={event => setId_enterprise(event.target.value)} value={id_enterprise} as="select" defaultValue="Choose...">
                                {enterprises.map(enterprise => (
                                    <option key={String(enterprise.id)} value={enterprise.id}>{enterprise.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} xs={2} controlId="formGridSellsman" >
                            <Form.Label>TRANPORTADORA</Form.Label>
                            <div>
                                <Checkbox checked={carrier} onChange={(e) => setCarrier(e.target.checked)} inputProps={{ 'aria-label': 'primary checkbox' }} />
                            </div>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>REFERENCIA COMERCIAL</Form.Label>
                            <Form.Control
                                value={reference_comercial}
                                className="form-control"
                                placeholder="Referencia comercial"
                                type="text"
                                onChange={(event) => {
                                    setReference_comercial(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} controlId="{`type-${index}`}">
                            <Form.Label>FORMA PAGAMENTO</Form.Label>
                            <Form.Control onChange={event => setPreference(event.target.value)} value={preference} as="select" defaultValue="Choose...">
                                {preferences.map(preference => (
                                    <option key={String(preference.id)} value={preference.description}>{preference.description}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xs={11} controlId="formGridName">
                            <Form.Label>OBSERVAÇÃO</Form.Label>
                            <Form.Control
                                value={obs}
                                className="form-control"
                                placeholder="Observação"
                                type="text"
                                onChange={(event) => {
                                    setObs(event.target.value)
                                }}
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formGridName">
                            <Form.Label>MENSAGEM ATUALIZAÇÃO</Form.Label>
                            <Checkbox checked={message} onChange={(e) => setMessage(e.target.checked)} inputProps={{ 'aria-label': 'primary checkbox' }} />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button type="submit" color="success">
                            Salvar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Cliente adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal >
    );
}

export default ModalUpdateClients;